import React from "react";

import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import FormRow from "components/form/FormRow";
import { useFieldValue } from "components/form/input/NestedField";
import { dateHoraToStringIso } from "util/date";
import PainelAgendaReuniao from "entity/Reuniao/components/PainelAgendaReuniao";
import Reuniao from "entity/Reuniao";

import DialogMesaBloqueio from "./DialogMesaBloqueio";
import DialogNewSchedule from "./DialogNewSchedule";

import { fetchArray } from "entity";
import useNotification from "notification";
import { isValid } from "date-fns";

export default function GeradorHorariosReuniao({ gerador, rodadaUid }) {
    const { showSuccess, showWarning } = useNotification();
    const [dataInicioT] = useFieldValue("dataInicio");
    const [dataFimT] = useFieldValue("dataFinal");
    const [tempoReuniao] = useFieldValue("tempoReuniao");
    const [intervaloEntreReuniao] = useFieldValue("intervaloReuniao");
    const [intervalos] = useFieldValue("intervalos");

    const dataInicio = dataInicioT && dataInicioT.toDate ? dataInicioT.toDate() : new Date(dataInicioT);
    const dataFim = dataFimT && dataFimT.toDate ? dataFimT.toDate() : new Date(dataFimT);
    const [possiveisReunioes, setPossiveisReunioes] = useFieldValue("possiveisReunioes");

    const getTaNoIntervalo = (hora) => {
        let fim = new Date(hora.getTime() + tempoReuniao * 60000);
        if (fim > dataFim) {
            return { fim: dataFim };
        }
        for (let index = 0; index < intervalos.length; index++) {
            const intervalo = intervalos[index];
            if (hora > new Date(intervalo.inicio) && hora < new Date(intervalo.fim)) {
                return intervalo;
            }
            if (fim > new Date(intervalo.inicio) && fim < new Date(intervalo.fim)) {
                return intervalo;
            }
        }
        return null;
    };

    const clearSchedule = async () => {
        const saveReunioes = async (values) => {
            let entity = new Reuniao();
            entity.update(values);
            entity
                .save()
                .then(() => {
                    console.log("reunião alterada com Sucesso");
                })
                .catch((e) => {
                    console.error(e.message);
                });
        };

        let query = await Reuniao.query();
        query = query.where("status", "==", "ATIVO");
        query = query.where("rodada.uid", "==", rodadaUid);
        let result = await fetchArray(query.get());

        result.forEach((r) => {
            r.status = "INATIVO";
            saveReunioes(r);
        });
    };

    const gerar = async () => {
        if (!dataInicio || !dataFim || !isValid(dataInicio) || !isValid(dataFim)) {
            showWarning("Data de início e fim deve ser informada");
            return;
        }
        if (tempoReuniao < 1 || intervaloEntreReuniao < 0) {
            showWarning("Tempo de cada reunião ou intervalo da reunião invalido");
            return;
        }
        await clearSchedule();

        let auxData = new Date(dataInicio);
        let reunioes = [];
        let minAdd = parseInt(tempoReuniao) + parseInt(intervaloEntreReuniao);
        let indice = 0;

        while (auxData < dataFim) {
            let taNoIntervalo = getTaNoIntervalo(auxData);
            if (!taNoIntervalo) {
                auxData.toISOString();
                reunioes.push({ horario: dateHoraToStringIso(auxData), indice });
                indice++;
                auxData = new Date(auxData.getTime() + minAdd * 60000);
            } else {
                auxData = new Date(taNoIntervalo.fim);
            }
        }

        setPossiveisReunioes(reunioes);
        showSuccess('Horários gerados na aba "Horários"');
    };

    const deleteReuniao = ({ index }) => {
        let array = possiveisReunioes.slice();
        array.splice(index, 1);
        setPossiveisReunioes(array);
    };

    return (
        <>
            {gerador ? (
                <FormRow
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "nowrap",
                    }}
                >
                    <Typography variant="h6">Número de horários para Reuniões: ({possiveisReunioes.length})</Typography>

                    <DialogNewSchedule gerarHorarios={gerar} confirmGerar={possiveisReunioes.length ? true : false} />
                </FormRow>
            ) : (
                <Box sx={{ display: "flex", flexBasis: "100%", flexDirection: "column", flex: 1 }}>
                    <FormRow
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "nowrap",
                        }}
                    >
                        <Typography variant="h6">
                            HORÁRIOS DE REUNIÕES ({possiveisReunioes.length}{" "}
                            {possiveisReunioes.length === 1 ? "REUNIÃO" : "REUNIÕES"})
                        </Typography>
                        {/* <Button onClick={gerar} style={{ margin: 20, alignSelf: "flex-end" }}>
                            GERAR HORÁRIOS
                        </Button> */}
                        <DialogNewSchedule
                            gerarHorarios={gerar}
                            confirmGerar={possiveisReunioes.length ? true : false}
                        />
                    </FormRow>
                    <PainelAgendaReuniao
                        hideLegenda
                        rodada={{ possiveisReunioes, intervalos }}
                        getActions={(horario) => {
                            return (
                                <>
                                    <DialogMesaBloqueio horario={horario} />
                                    <Tooltip title="DELETAR HORÁRIO">
                                        <IconButton aria-label="delete" onClick={() => deleteReuniao(horario)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                </>
                            );
                        }}
                    />
                </Box>
            )}
        </>
    );
}
